import React, { useEffect, useState } from 'react';
import { authService, User } from '../services/auth';
import PortfolioDashboard from '../components/dashboard/portfolio-dashboard';

const DashboardPage: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      try {
        await authService.waitForInitialization();
        
        if (authService.isAuthenticated()) {
          const currentUser = await authService.getCurrentUser();
          setUser(currentUser);
        }
      } catch (error) {
        console.error('Failed to load user:', error);
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, var(--obsidian-black) 0%, #1a1d23 100%)' }} />
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, var(--obsidian-black) 0%, #1a1d23 100%)' }}>
        <div className="flex items-center justify-center h-screen">
          <div className="text-center">
            <p className="text-[var(--platinum-silver)]">Please log in to access the dashboard</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-page">
      <PortfolioDashboard />
    </div>
  );
};

export default DashboardPage; 